import { useEffect, useState } from "react";
import { EXAMPLE_REFUSAL, EXAMPLE_REFUSED_EVENT, enterExample, exampleActive, exampleEvents, leaveExample } from "../lib/example/mode";

/* THE EXAMPLE WORKSPACE'S LABEL — on every page while the example is on (2026-09-28). A strip across the top of the
 * window, above the sidebar and the page, saying in words that the people are made up and nothing saves, with the one
 * way out. It is not dismissible: a label a coach can close is a label that stops labelling. When a save is refused it
 * says so for a moment in the same strip, so a button that "did nothing" is never a mystery. */
export function ExampleBanner() {
  const [refused, setRefused] = useState(false);
  useEffect(() => {
    if (!exampleActive()) return;
    document.documentElement.dataset.example = "on";
    let timer: number | undefined;
    const on = () => { setRefused(true); window.clearTimeout(timer); timer = window.setTimeout(() => { setRefused(false); }, 4000); };
    exampleEvents.addEventListener(EXAMPLE_REFUSED_EVENT, on);
    return () => { exampleEvents.removeEventListener(EXAMPLE_REFUSED_EVENT, on); window.clearTimeout(timer); delete document.documentElement.dataset.example; };
  }, []);
  if (!exampleActive()) return null;
  return (
    <div className="example-banner" role="status">
      <span className="example-banner-tag">Example</span>
      <span className="example-banner-text" aria-live="polite">
        {refused ? EXAMPLE_REFUSAL : (
          <>
            <span className="example-banner-wide">Made-up clients and training, so you can look around. Nothing here is real or saved.</span>
            <span className="example-banner-narrow">Made up · nothing saves</span>
          </>
        )}
      </span>
      <button type="button" className="example-banner-leave" onClick={leaveExample}>
        <span className="example-banner-wide">Leave example</span><span className="example-banner-narrow">Leave</span>
      </button>
    </div>
  );
}

/** The way in, offered where a coach with no clients would otherwise see an empty page. */
export function SeeExampleLink() {
  if (exampleActive()) return null;
  return (
    <>
      {" "}Or <button type="button" className="ht-link" onClick={enterExample}>see an example workspace</button> — made-up clients, a logged week and reviews, to look around first.
    </>
  );
}
